import PlanCard from "../components/ui/PlanCard";
import { PLANS } from "../utils/constants";

export default function Pricing({ currentPlan = "free", showToast }) {
  return <main><h1 className="text-2xl font-black">Plans</h1><p className="mt-1 text-sm text-tg-hint">Upgrade with Razorpay, Telegram Stars, or referral balance.</p><div className="mt-5 grid gap-3">{PLANS.map((plan)=><PlanCard key={plan.id} plan={plan} current={plan.id===currentPlan} onBuy={(p)=>showToast?.(`${p.name} checkout will open in Telegram.`)} />)}</div></main>;
}
